import { colors } from '@fs/zion-ui'

export const REVIEWED_COLOR = colors.green05
export const IN_PROGRESS_COLOR = colors.yellow05
export const DISABLED_BACKGROUND_COLOR = colors.gray10
export const DISABLED_FOREGROUND_COLOR = colors.gray60
export const DISABLED_TEXT_COLOR = colors.gray60
